import React, { lazy, Suspense } from 'react';
import { LazyMotion, domAnimation } from 'framer-motion';
import { Hero } from './components/sections/Hero';
import { StickyCTA } from './components/ui/StickyCTA';

// Everything below the hero is code-split into its own chunk and loaded right
// after the initial paint — none of it is needed to render the first screen,
// so it shouldn't compete with the hero/LCP for the browser's main thread.
const TrustStats = lazy(() => import('./components/sections/TrustStats').then(mod => ({
  default: mod.TrustStats
})));
const Transformation = lazy(() => import('./components/sections/Transformation').then(mod => ({
  default: mod.Transformation
})));
const Method = lazy(() => import('./components/sections/Method').then(mod => ({
  default: mod.Method
})));
const ForYou = lazy(() => import('./components/sections/ForYou').then(mod => ({
  default: mod.ForYou
})));
const WhatYouGet = lazy(() => import('./components/sections/WhatYouGet').then(mod => ({
  default: mod.WhatYouGet
})));
const InstantAccess = lazy(() => import('./components/sections/InstantAccess').then(mod => ({
  default: mod.InstantAccess
})));
const LookInside = lazy(() => import('./components/sections/LookInside').then(mod => ({
  default: mod.LookInside
})));
const Testimonials = lazy(() => import('./components/sections/Testimonials').then(mod => ({
  default: mod.Testimonials
})));
const BonusesDetail = lazy(() => import('./components/sections/BonusesDetail').then(mod => ({
  default: mod.BonusesDetail
})));
const AboutAuthor = lazy(() => import('./components/sections/AboutAuthor').then(mod => ({
  default: mod.AboutAuthor
})));
const Pricing = lazy(() => import('./components/sections/Pricing').then(mod => ({
  default: mod.Pricing
})));
const Guarantee = lazy(() => import('./components/sections/Guarantee').then(mod => ({
  default: mod.Guarantee
})));
const FAQ = lazy(() => import('./components/sections/FAQ').then(mod => ({
  default: mod.FAQ
})));
const FinalCTA = lazy(() => import('./components/sections/FinalCTA').then(mod => ({
  default: mod.FinalCTA
})));
const Footer = lazy(() => import('./components/sections/Footer').then(mod => ({
  default: mod.Footer
})));
export function App() {
  return <LazyMotion features={domAnimation} data-id="element-0" data-mp="d3mi75km8lhi">
      <div className="w-full min-h-full bg-bg-primary font-body text-white" data-id="element-1" data-mp="d2bj3j2481wq">
        <main data-id="element-2" data-mp="86cnbaegjhma">
          <Hero data-id="element-3" data-mp="83i6dsunkexm" />
          <Suspense fallback={null} data-id="element-4" data-mp="3gle9siuub3f6">
            <TrustStats data-id="element-5" data-mp="3gmfvdh9hf8b5" />
            <Transformation data-id="element-6" data-mp="3glo0k8nplelx" />
            <Method data-id="element-7" data-mp="3bmbf9schkflg" />
            <ForYou data-id="element-8" data-mp="3bmtgz4hx3m0r" />
            <WhatYouGet data-id="element-9" data-mp="3bnmh3mmdfd9x" />
            <InstantAccess data-id="element-10" data-mp="3bo4l55f9yvse" />
            <LookInside data-id="element-11" data-mp="3qb7jfebf98gs" />
            <Testimonials data-id="element-12" data-mp="3qbfv52vt67qe" />
            <BonusesDetail data-id="element-13" data-mp="3qcr0h74wjnjm" />
            <AboutAuthor data-id="element-14" data-mp="3qd0st1df66sh" />
            <Pricing data-id="element-15" data-mp="3ljxvqj9fof7j" />
            <Guarantee data-id="element-16" data-mp="3ljg1fs6c0b29" />
            <FAQ data-id="element-17" data-mp="3lj6ao2dgpzvi" />
            <FinalCTA data-id="element-18" data-mp="3limrkic2t5fw" />
          </Suspense>
        </main>
        <Suspense fallback={null} data-id="element-19" data-mp="2xtlqxh9hiyl6">
          <Footer data-id="element-20" data-mp="2xssf41vo5iw6" />
        </Suspense>
        <StickyCTA data-id="element-21" data-mp="2swbtpffutims" />
      </div>
    </LazyMotion>;
}